import DocumentIcon from './icons/document.svg?react';

type FilePreviewProps = {
  isImage: boolean;
  previewUrl?: string;
};

export const FilePreview = ({ isImage, previewUrl }: FilePreviewProps) => {
  return (
    <div
      className={`
        flex size-11 shrink-0 overflow-hidden rounded-lg border
        border-black-transparent-300
      `}
    >
      {isImage && previewUrl ? (
        <img
          src={previewUrl}
          alt=""
          className={`pointer-events-none size-full rounded-lg object-cover`}
        />
      ) : (
        <DocumentIcon className="place-self-center" />
      )}
    </div>
  );
};
